import { RestClient } from './RestClient'
import store from 'src/store'

export class ActivitiesClient extends RestClient {
  /**
   * ActivitiesClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/activities`
  }

  /**
   * List all activities for a team
   *
   * @param {number} team
   *
   * @returns {AxiosPromise}
   */
  list (team) {
    return this.call('get', this.baseUrl)
  }
}
